import React, { useState } from 'react';
import { Grid, Box, Typography, TextField, Button, InputAdornment } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { useNavigate ,useLocation} from 'react-router-dom';
import axios from 'axios'
import Swal from 'sweetalert2'


export default function Forgotpasswordpage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState({ email: "" });

  const handler = (e) => {
    const { name, value } = e.target;
    setEmail({ ...email, [name]: value });
  };

  const sendotp = () => {
    axios.post(`${process.env.REACT_APP_API_LINKS}/forgot/sendotp`, email)
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'OTP Sent Successfully!',
            timer: 1000,
            showConfirmButton: false
          });
          navigate('/verifyotp', { state: { email: email.email } });
        }
      })
      .catch((err) => {
        if (err.status === 300) {
          Swal.fire({
            icon: 'error',
            title: 'No user found!',
            text: 'no users with that email.',
            timer: 1000,
            showConfirmButton: false
          });
        }
        else {


          Swal.fire({
            icon: 'error',
            title: 'Failed to send OTP!',
            text: 'An error occurred while sending the OTP.',
            timer: 1000,
            showConfirmButton: false
          });
        }
      });

  };

  return (
    <Grid container sx={{ minHeight: '100vh', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', justifyContent: 'center', p: { xs: 2, md: 4 } }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: { xs: 3, sm: 4 },
          textAlign: 'center',
          mx: 'auto',
          fontFamily: 'poppins'
        }}
      >
        <img
          src="suntech_logo.png"
          alt="Company Logo"
          style={{ height: 75, marginBottom: 10 }}
        />

        <img
          src="3d-password-field-with-padlock-isolated.png"
          alt="Forgot Password"
          style={{ width: '70%', maxWidth: 500, marginTop: 5 }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: { xs: 2, sm: 4 },
          mx: 'auto'
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            p: 4,
            borderRadius: 2,
            textAlign: 'center',
            backgroundColor: '#fff',
            boxShadow: '1px 1px 20px rgba(128, 128, 128, 0.7)',
          }}
        >
          <Typography variant="h5" sx={{ fontFamily: 'poppins', mb: 3, fontWeight: 600 }}>
            Forgot Password
          </Typography>

          <TextField
            fullWidth
            label="Email"
            name="email"
            placeholder="Enter Your Registered Email"
            variant="outlined"
            margin="normal"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
            onChange={handler}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: '#007ee5',
              mt: 2,
              textTransform: 'none',
              fontWeight: 600,
              fontFamily: 'poppins',
              borderRadius: '10px',
              width: 'max-content'

            }}
            onClick={sendotp}
          >
            Send OTP
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}
